<template>
  <div class="filter-group">
    <label class="filter-label">
      <v-icon small color="#023449" class="mr-1">{{ icon }}</v-icon>
      {{ label }}
      <v-chip v-if="internalValue.length > 0" x-small color="rgba(2, 52, 73, 0.1)" text-color="#023449" class="ml-auto filter-badge">
        {{ internalValue.length }}
      </v-chip>
    </label>

    <v-autocomplete
        v-model="internalValue"
        :items="items"
        :item-text="itemText"
        :item-value="itemValue"
        :label="`Selecione as ${label.toLowerCase()}`"
        :menu-props="{ closeOnContentClick: true }"
        multiple dense outlined hide-details
        @change="handleChange"
        color="#023449"
        class="custom-select"
        :disabled="loading"
        :readonly="loading"
        ref="autocomplete"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 2" small color="#023449" text-color="white" class="mr-1">
          {{ item[itemText] }}
        </v-chip>
        <span v-if="index === 2" class="grey--text text-caption">
          (+{{ internalValue.length - 2 }})
        </span>
      </template>
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item
            v-bind="attrs"
            v-on="loading ? {} : on"
            :disabled="loading"
            :class="{ 'item-disabled': loading }"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item[itemText] }}</v-list-item-title>
            <v-list-item-subtitle>ID: {{ item[itemValue] }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>

    <div class="select-actions">
      <v-btn text x-small color="#023449" @click="selectAll" :disabled="loading">
        Selecionar Todas
      </v-btn>
      <v-btn v-if="internalValue.length > 0" text x-small color="error" @click="clear" :disabled="loading">
        Limpar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectFilter',

  props: {
    value: { type: Array, required: true },
    items: { type: Array, required: true },
    itemText: { type: String, required: true },
    itemValue: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: String, required: true },
    loading: Boolean
  },

  data() {
    return {
      internalValue: [...this.value]
    };
  },

  watch: {
    value(newVal) {
      this.internalValue = [...newVal];
    }
  },

  methods: {
    handleChange() {
      this.emitChange();
      // Fecha o menu após a seleção
      this.$nextTick(() => {
        if (this.$refs.autocomplete) {
          this.$refs.autocomplete.isMenuActive = false;
        }
      });
    },

    emitChange() {
      this.$emit('input', [...this.internalValue]);
      this.$emit('change');
    },

    selectAll() {
      if (this.loading) return;
      this.internalValue = this.items.map(item => item[this.itemValue]);
      this.emitChange();
    },

    clear() {
      if (this.loading) return;
      this.internalValue = [];
      this.emitChange();
    }
  }
};
</script>

<style scoped>
.filter-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(2, 52, 73, 0.05);
  transition: all 0.2s ease;
}

.filter-group:hover {
  border-color: #023449;
  box-shadow: 0 2px 4px rgba(2, 52, 73, 0.08);
}

.filter-label {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #023449;
  font-size: 0.938rem;
  letter-spacing: -0.01em;
  margin-bottom: 4px;
}

.filter-label .v-chip {
  margin-left: auto;
  font-weight: 600;
}

.filter-badge {
  min-width: 28px;
  height: 22px;
  font-weight: 700;
  border-radius: 6px;
}

.custom-select >>> .v-input__control {
  min-height: 44px !important;
}

.custom-select >>> fieldset {
  border-color: #e5e7eb;
  border-width: 2px;
  transition: all 0.2s ease;
}

.custom-select >>> .v-input__slot {
  background: #ffffff;
  transition: all 0.2s ease;
}

.custom-select >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.custom-select.v-input--is-disabled >>> fieldset {
  border-color: #e5e7eb !important;
}

.custom-select.v-input--is-disabled >>> .v-input__slot {
  cursor: not-allowed !important;
  background-color: #f9fafb !important;
}

.custom-select.v-input--is-disabled >>> .v-select__selections {
  cursor: not-allowed !important;
}

.custom-select >>> .v-select__selections {
  min-height: 42px;
}

.custom-select >>> .v-chip {
  font-weight: 600;
  border-radius: 8px;
}

.item-disabled {
  pointer-events: none !important;
  opacity: 0.4 !important;
  background-color: #f8fafc !important;
  cursor: not-allowed !important;
}

.item-disabled .v-list-item__title,
.item-disabled .v-list-item__subtitle {
  color: #94a3b8 !important;
}

.item-disabled:hover {
  background-color: #f8fafc !important;
}

.select-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  padding-top: 4px;
}

.select-actions >>> .v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 0.813rem;
  padding: 0 12px !important;
  min-width: auto;
  transition: all 0.2s ease;
}

.select-actions >>> .v-btn:hover {
  transform: translateX(2px);
}
</style>